<template>
    <div>
        <AppHeader />
        <br />
        <div class="container-fluid">
            <v-overlay :value="loading">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-overlay>
            <AppTable :cargadores="Listacargadores" ref="tableComponent" />
        </div>
        <!-- <br>
        <button @click="Eliminar">Ejecutar Función</button> -->

    </div>
</template>

<script>
import AppHeader from '@/components/HeaderC.vue'
import AppTable from '@/components/TableC.vue'
import axios from 'axios'

export default {
    name: 'InscripcionesView',
    data() {
        return {
            Listacargadores: [],
            loading: false,
            validToken: false
        }
    },
    components: {
        AppHeader,
        AppTable
    },
    mounted: function () {

        this.obtieneRegistros();

    },
    methods: {
        validateToken() {

            // const token = localStorage.token
            const token = this.$cookies.get('token');
            this.loading = true;
            const apiUrl = `https://wm1xvvtarj.execute-api.us-east-1.amazonaws.com/dev/validateToken?token=${token}`;
            this.loading = true;
            // const apiUrl = `https://wm1xvvtarj.execute-api.us-east-1.amazonaws.com/dev/validateToken?token=${token}`;
            // Configuración para la solicitud GET con el token en el encabezado Authorization

            // Realizar solicitud GET a la API original con el token en el encabezado
            return axios.get(apiUrl)
                .then(response => {

                    const username = response.data.decoded.username;
                    this.$cookies.set('username', username, '1d', '', '', true, 'Strict');
                    // localStorage.username = response.data.decoded.username;
                    this.validToken = true;
                    this.loading = false; // Desactivar animación de carga

                })
                .catch(() => {
                    this.validToken = false
                    // console.error(error)
                    //  console.error('Error al obtener datos de la API', error);
                    this.loading = false; // Desactivar animación de carga en caso de error
                });
        },
        clearAllCookies() {
            const allCookies = this.$cookies.keys();
            for (const cookie of allCookies) {
                this.$cookies.remove(cookie);
            }
        },
        async obtieneRegistros() {

            await this.validateToken();
            if (!this.validToken) {
                // localStorage.clear
                this.clearAllCookies();
                // this.$router.push('/');
                return
            }
            const apiUrl = `https://62jecp6v6f.execute-api.us-east-1.amazonaws.com/dev/api/cargadores?usuarioResponsable=${this.$cookies.get('username')}`;
            const token = this.$cookies.get('token');
            // Configuración para la solicitud GET con el token en el encabezado Authorization
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            this.loading = true; // Activar animación de carga
            // Realizar solicitud GET a la API original con el token en el encabezado
            axios.get(apiUrl, config)
                .then(response => {

                    this.Listacargadores = response.data.records[0]
                    this.loading = false; // Desactivar animación de carga

                })
                .catch(() => {
                    // console.error('Error al obtener datos de la API', error);
                    this.loading = false; // Desactivar animación de carga en caso de error
                });
        }
    }
}
</script>

<style scoped></style>